module.exports = __webpack_public_path__ + "img/1.ff89512e.png";